import { OrderSoundtrackItem } from "../../types/OrderSoundtrackItem";

export interface SequencedSoundtrack {
    id: string;
    index: number;
}

export const getSequencedSoundtrackIds = ({
    soundtracks
}: {
    soundtracks: OrderSoundtrackItem[];
}): SequencedSoundtrack[] => {
    return soundtracks.map((item) => ({ id: item.id, index: item.index }));
};
